export default __webpack_public_path__ + "static/media/icon-pre-cotizacion.fdbfd20a.svg";